import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ProcessRTSBarcodeResponse,
  ReturnToStationDownloadResponse,
  ReturnToStationUIResponse,
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { ReturnToStationResponse } from "../../models/responseModels/returnToStationResponse";
import { ProcessBarcodeRequest } from "../../models/requestModels/processBarcode";

type InitialState = {
  isLoading: boolean;
  returnToStationList: ReturnToStationResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  returnToStationList: [],
  errorMessage: null,
};

export const getReturnToStationList =
  createAsyncThunk<ReturnToStationUIResponse>(
    "returnToStation/returnToStationResponse",
    async () => {
      const response =
        await agent.ReturnToStationAgent.getReturnToStationList();
      return response;
    }
  );

export const downloadReturnToStationDataToCsv = createAsyncThunk<
  ReturnToStationDownloadResponse,
  ReturnToStationResponse[]
>(
  "returnToStation/downloadCsv",
  async (returnToStationData: ReturnToStationResponse[]) => {
    const response =
      await agent.ReturnToStationAgent.returnToStationCsvDownload(
        returnToStationData
      );
    return response;
  }
);

export const downloadReturnToStationDataToXlsx = createAsyncThunk<
  Blob,
  ReturnToStationResponse[]
>(
  "returnToStation/downloadXlsx",
  async (returnToStationData: ReturnToStationResponse[]) => {
    const response =
      await agent.ReturnToStationAgent.returnToStationXlsxDownload(
        returnToStationData
      );
    return response;
  }
);

export const processBarcodeForRTS = createAsyncThunk<
  ProcessRTSBarcodeResponse,
  ProcessBarcodeRequest
>(
  "returnToStation/processBarcode",
  async (processBarcodeRequest: ProcessBarcodeRequest) => {
    const response =
      await agent.ReturnToStationAgent.processBarcodeForReceiving(
        processBarcodeRequest
      );
    return response;
  }
);

const returnToStationSlice = createSlice({
  name: "returnToStation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReturnToStationList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReturnToStationList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.returnToStationList = action.payload.data;
        } else {
          state.returnToStationList = [];
        }
      })
      .addCase(getReturnToStationList.rejected, (state, action) => {
        state.isLoading = false;
        state.returnToStationList = [];
        state.errorMessage = action.error.message!;
      })
      .addCase(downloadReturnToStationDataToCsv.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadReturnToStationDataToCsv.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(downloadReturnToStationDataToCsv.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message!;
      })
      .addCase(downloadReturnToStationDataToXlsx.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadReturnToStationDataToXlsx.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(downloadReturnToStationDataToXlsx.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message!;
      });
  },
});

export default returnToStationSlice.reducer;
